import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const IntroOverlay = () => {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("cb_intro");
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!show) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(
      () => {
        setShow(false);
        try {
          sessionStorage.setItem("cb_intro", "1");
        } catch { /* private mode */ }
      },
      reduced ? 300 : 2300
    );
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          className="fixed inset-0 z-[200] flex items-center justify-center bg-obsidian"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="text-center">
            <div className="overflow-hidden">
              <motion.p
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                className="font-display text-3xl tracking-[0.28em] text-ivory sm:text-5xl"
              >
                CELEBRITY
              </motion.p>
            </div>
            <div className="overflow-hidden">
              <motion.p
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.32, ease: [0.22, 1, 0.36, 1] }}
                className="mt-2 text-[11px] font-semibold uppercase tracking-[0.7em] text-gold sm:text-sm"
              >
                Bouncers
              </motion.p>
            </div>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.9, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mx-auto mt-6 h-px w-40 origin-center bg-gold/60"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
